import { useContext, useState } from 'react';

import {
  Alert,
  Button,
  Icons,
  ScrollableDialogContent,
  DialogFooter,
  Typography,
  Stack,
} from '@cast/design-system';

import { GetScriptContent } from './_components/GetScriptContent';
import { SelectProvider } from './_components/SelectProvider';
import {
  DialogHeading,
  IRanTheScriptButton,
  StepContainer,
} from '../../../../_components/new-onboarding';
import { PROVIDERS_WITHOUT_FEATURE_SELECTION } from '../../../constants';
import { OnboardClusterContext } from '../../../OnboardClusterProvider';

type Props = {
  onClose: () => void;
  onSwitchToCastctl: () => void;
};

export const SelectProviderStep = ({ onClose, onSwitchToCastctl }: Props) => {
  const [hasScript, setHasScript] = useState(false);
  const { provider, selectFeatures, handleWaitForConnection } = useContext(
    OnboardClusterContext
  );

  const scriptIsRequired =
    PROVIDERS_WITHOUT_FEATURE_SELECTION.includes(provider);

  return (
    <StepContainer data-testid="select-provider-step">
      <DialogHeading onClose={onClose} hideTerraformLink>
        Connect your K8s cluster
      </DialogHeading>
      <ScrollableDialogContent>
        <Stack gap={16}>
          <Stack gap={24}>
            <SelectProvider />

            <GetScriptContent onHasScriptChanged={setHasScript} />
          </Stack>
          <Alert severity="info" color="info" size="sm">
            <Typography
              variant="P10R"
              color="text.primary"
              alignContent="baseline"
            >
              We&apos;ve upgraded onboarding with Castctl — our new CLI tool
              built to replace the legacy bash script.{' '}
              <Button
                variant="text"
                size="sm"
                sx={{ position: 'relative', top: -1 }}
                onClick={onSwitchToCastctl}
                testId="switch-to-castctl-button"
              >
                Try Castctl
              </Button>
            </Typography>
          </Alert>
        </Stack>
      </ScrollableDialogContent>

      {(() => {
        if (scriptIsRequired) {
          return hasScript ? (
            <DialogFooter
              end={<IRanTheScriptButton onClick={handleWaitForConnection} />}
            />
          ) : null;
        }

        return (
          <DialogFooter
            end={
              <Button
                testId="next-button"
                endIcon={<Icons.ArrowRight />}
                onClick={selectFeatures}
              >
                Next
              </Button>
            }
          />
        );
      })()}
    </StepContainer>
  );
};
